// extracted by mini-css-extract-plugin
export default {"root":"style_root__kHCfI","label":"style_label__ImuSA","link":"style_link__EBKuK","off":"style_off__j-+ba","channel":"style_channel__RuQNn"};